var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeForInputField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.136647 4.42325C0.936288 5.42533 3.31496 8.09755 6.12889 8.09755C8.94281 8.09755 11.3215 5.42544 12.1211 4.42325C12.2931 4.20057 12.2931 3.88679 12.1211 3.67433C11.3215 2.67224 8.94281 2.86766e-05 6.12889 2.86766e-05C3.31496 -0.0100934 0.936288 2.66212 0.136647 3.6642C-0.0455491 3.88689 -0.0455491 4.20057 0.136647 4.42325ZM6.12889 1.60943C7.47512 1.60943 8.55818 2.69249 8.55818 4.03872C8.55818 5.38495 7.47512 6.46801 6.12889 6.46801C4.78266 6.46801 3.6996 5.38495 3.6996 4.03872C3.6996 2.69249 4.78266 1.60943 6.12889 1.60943Z",
    fill: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12919 5.25448C6.80002 5.25448 7.34384 4.71067 7.34384 4.03984C7.34384 3.36901 6.80002 2.8252 6.12919 2.8252C5.45837 2.8252 4.91455 3.36901 4.91455 4.03984C4.91455 4.71067 5.45837 5.25448 6.12919 5.25448Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeForInputField);
export default __webpack_public_path__ + "static/media/eyeForInputField.4fa6e0855b19e33e2969695e37f19489.svg";
export { ForwardRef as ReactComponent };